module.exports = __webpack_public_path__ + "img/fuwuxiagnmu_jpg1_fwxq.732889bd.png";